const rankings = [
  { id: 1, title: '顶流男星深夜密会被拍，神秘女子身份曝光', heat: '203.8万', trend: 'up' },
  { id: 2, title: '某偶像团体成员涉毒被警方带走，演唱会取消', heat: '198.5万', trend: 'up' },
  { id: 3, title: '清纯女星私密派对视频流出引全网热议', heat: '176.2万', trend: 'up' },
  { id: 4, title: '知名导演潜规则录音曝光，圈内人站队表态', heat: '152.7万', trend: 'up' },
  { id: 5, title: '婚内出轨实锤！国民老公形象崩塌品牌解约', heat: '141.3万', trend: 'new' },
  { id: 6, title: '某综艺咖素颜照流出引发网友激烈讨论', heat: '125.9万', trend: 'down' },
  { id: 7, title: '网红圈大型翻车事件：多博主同时人设崩塌', heat: '108.4万', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">吃瓜热榜</h2>
          <p className="text-sm text-foreground-500">实时更新 · 全网最热吃瓜话题排名</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <a
              key={item.id}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 no-underline hover:bg-background-50 transition-colors cursor-pointer ${
                idx < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
                idx === 0 ? 'bg-accent-500 text-background-50' :
                idx === 1 ? 'bg-accent-400 text-background-50' :
                idx === 2 ? 'bg-accent-300 text-accent-800' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.id}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.title}</h3>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.trend === 'up' && (
                  <span className="text-xs text-green-600 flex items-center gap-0.5">
                    <i className="ri-arrow-up-line text-xs"></i>
                  </span>
                )}
                {item.trend === 'down' && (
                  <span className="text-xs text-red-500 flex items-center gap-0.5">
                    <i className="ri-arrow-down-line text-xs"></i>
                  </span>
                )}
                {item.trend === 'new' && (
                  <span className="text-xs text-accent-500 font-medium">NEW</span>
                )}
                <span className="text-xs text-foreground-400 flex items-center gap-0.5 whitespace-nowrap">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}